import React from 'react';
import {
  Form,
  Radio,
  Input,
  Divider,
  Checkbox,
  UploadFile,
  Row,
  FormInstance,
} from 'antd';
import { useTranslation } from 'react-i18next';
import ImageUpload from '@components/ImageUpload';
import ButtonHelp from '@components/ButtonHelp';

import * as S from './styles';

interface BannerExtraDetailsProps {
  form: FormInstance<any>;
  defaultFile?: UploadFile<any>;
}

const BannerExtraDetails = ({ form, defaultFile }: BannerExtraDetailsProps) => {
  const { t } = useTranslation('banners');
  const detailsType = Form.useWatch('detailsType', form);
  const enabledDefaultButton = Form.useWatch('enabledDefaultButton', form);

  return (
    <S.Container>
      <Divider
        className="banner-extra-details-divider"
        style={{ marginBottom: 16 }}
      >
        {t('modal.additional-information')}
      </Divider>
      <Row justify="center">
        <Form.Item name="detailsType">
          <Radio.Group
            onChange={({ target: { value } }) => {
              form?.setFieldValue('detailsType', value);
            }}
          >
            <Radio.Button value="url">{t('modal.details.link')}</Radio.Button>
            <Radio.Button value="img">{t('modal.details.img')}</Radio.Button>
          </Radio.Group>
        </Form.Item>
      </Row>
      {detailsType === 'url' && (
        <Form.Item
          name="link"
          label="URL"
          rules={[
            {
              required: true,
              message: t('msgs.required'),
            },
          ]}
        >
          <Input />
        </Form.Item>
      )}
      {detailsType === 'img' && (
        <Form.Item
          name="fileDetail"
          style={{ margin: 0, marginBottom: 16 }}
          rules={[
            {
              required: true,
              message: t('msgs.required'),
            },
          ]}
        >
          <ImageUpload defaultFile={defaultFile} />
        </Form.Item>
      )}
      <Row>
        <Form.Item
          name="enabledDefaultButton"
          valuePropName="checked"
          style={{ marginBottom: 0 }}
        >
          <Checkbox>
            {t('modal.enabled-default-button')}
            <ButtonHelp text={t('modal.default-button-help')} />
          </Checkbox>
        </Form.Item>
      </Row>
      {enabledDefaultButton && (
        <Form.Item name="buttonText" style={{ margin: '16px 0 8px 0' }}>
          <Input placeholder={t('modal.button-default-text')} />
        </Form.Item>
      )}
    </S.Container>
  );
};

export default BannerExtraDetails;
